import React, { useContext, useState } from 'react';
import Icons from '../Icons';
import { Context } from "../contexts/AppContext";

function UploadImageVideoThumbnail(props) {
  const [imageFile, setImageFile] = useState(null);
  const { value } = useContext(Context);
  const [appState] = value;
  const [clickType, setClickType]=useState(null)
  console.log('types----- ',props.type)

  const { currentFolderData, currentFolderName, currentGalleryName,currentGalleryData,currentDBVideoId } = appState;

  // Handle file input
  const handleFileChange = async (event) => {
     const inputId = event.target.id; // 🟢 Get full ID like "fileInput-logo"
  const typeFromId = inputId.replace("fileInput-", ""); // 🟡 Extract "logo", "background", etc.
  
    const file = event.target.files[0];
    if (file) {
      props.imgOnPrg()
      setImageFile(file);
      await handleUpload(file,typeFromId);
    }
  };

  // Get Presigned URL from Backend
  const getPresignedUrl = async (file) => {
  
     const folderPath = props.baseUrl?props.baseUrl:`${currentFolderData.adminId}/${currentFolderData.id}/${currentGalleryData._id}/${currentDBVideoId}`;
      console.log(folderPath,'appState Upload Image Bg----',appState)
    const presignedApi = `${process.env.REACT_APP_API_PATH}products/generate-presigned-url?folderPath=${folderPath}&fileName=${file.name}&fileType=${file.type}`;
console.log('presigned Api ',presignedApi)
    const response = await fetch(presignedApi, {
      method: "POST",
      headers: { "Content-Type": "image/jpeg" },
      CacheControl: "no-store",
      body: JSON.stringify({
        file_name: `${folderPath}/${file.name}`,
      }),
    });

    return response.json();
  };

  // Upload to S3
  const handleUpload = async (file,typeFromId) => {
    
    try {
      const data = await getPresignedUrl(file);
    
      const { upload_url } = JSON.parse(data.body);
      console.log("DATA ",upload_url)
      const xhr = new XMLHttpRequest();
      xhr.open("PUT", upload_url, true);

      xhr.upload.onprogress = function (event) {
        if (event.lengthComputable) {
          const percentComplete = (event.loaded / event.total) * 100;
         props.imgOnPrg()
         
        }
      };

      xhr.onload = function () {
        if (xhr.status === 200) {
          console.log("Image uploaded successfully",props.type);
          const timestamp = Date.now();
          const updatedUrl = `${file.name}?t=${timestamp}`;
          props.imgUploadedDone(file, typeFromId);
        } else {
          console.error("Upload failed with status:", xhr.status);
         props.uploadFailed(file)
        }
      };

      xhr.onerror = function () {
        console.log("Network error");
        alert("Network error during upload");
      };

      xhr.send(file);
    } catch (error) {
      console.error("Error uploading image:", error);
    }
  };

  // Optional: Delete from S3
  const deleteFileFromS3 = async (fileName) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_PATH}/products/delete-file`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ fileName }),
      });

      const data = await response.json();
      alert(data.message);
    } catch (error) {
      console.error("Error deleting image:", error);
    }
  };

  return (
    <div  className=''>
      {imageFile && <img src="/img/spinner.gif" alt="spinner" style={{ width: "20px", padding: "10px" }} />}
      
      <input
        type="file"
        accept="image/*"
        onChange={handleFileChange}
       id={`fileInput-${props.type}`} 
        style={{ display: "none" }}
      />

    <button
  onClick={() => document.getElementById(`fileInput-${props.type}`).click()}
  className="btn-yellow"
>
  {props?.txt ? props.txt : "Upload Image"}
</button>
    </div>
  );
}

export default UploadImageVideoThumbnail;
